module.exports = __webpack_public_path__ + "img/item_31.96fe071e.png";